module.exports = __webpack_public_path__ + "static/media/Woman-in-lingerie-451109.769ae2f0.jpg";